export const downloadFileFromBlob = (blob: Blob, fileTitle: string = "") => {
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    if (!!fileTitle) {
        a.download = fileTitle;
    }
    a.click();
};

